module.exports = __webpack_public_path__ + "images/marketing/email/external-user-invitation.png";